import Accordion from './components/Accordion';
import createScrollableElements, {
    centerMiddleElementInScrollableContainer,
    scrollOnHover,
} from './components/scrollable';
import StateManager from './components/StateManager';
import { isSmallViewport, isMediumViewport } from 'common/utils/viewport-detection';
import SlideCarousel from './components/slide-carousel';

document.addEventListener('DOMContentLoaded', () => {
    Accordion.create('[data-accordion]');
    SlideCarousel.create();
    initScrollables();
    setupCommunitySection();
    setupDreamJobSection();
});

function initScrollables() {
    createScrollableElements();
    scrollOnHover('[data-scrollable]');

    centerMiddleElementInScrollableContainer('[data-scrollable="designs"]');

    const designCards = document.querySelectorAll('[data-design-card]');
    for (var i = 0; i < designCards.length; i++) {
        designCards[i].style.visibility = 'visible';
    }
}

function getCommunitySectionColSize() {
    const communitySection = document.querySelector('[data-community-section-content]');
    const firstColumn = communitySection.querySelectorAll('[data-community-section-column]')[0];
    return firstColumn.offsetWidth;
}

function changeCommunityColColorOnScroll(colorPropagator, itemSize) {
    const container = document.querySelector('[data-community-section-content]');
    const scrollableContainer = container.querySelector('[data-scrollable-inner]');

    const scrollableContainerChildren = container.querySelectorAll(
        '[data-community-section-column]'
    );

    scrollableContainer.addEventListener('scroll', () => {
        if (isSmallViewport() || isMediumViewport()) {
            const focusedChildPos = Math.min(
                Math.floor(scrollableContainer.scrollLeft / (itemSize / 2)),
                scrollableContainerChildren.length - 1
            );

            const focusedChild = scrollableContainerChildren[focusedChildPos];

            if (focusedChild) {
                colorPropagator.propagateStateForElement(focusedChild);
            }
        }
    });
}

function setupCommunitySection() {
    const communitySectionColorPropagator = new StateManager({
        receiverTarget: 'community-section',
        eventThatAssigns: 'mouseover',
        eventThatResets: 'mouseout',
        defaultState: 'find-opportunity',
    });

    const communitySectionColSize = getCommunitySectionColSize();
    changeCommunityColColorOnScroll(communitySectionColorPropagator, communitySectionColSize);
}

function setupDreamJobSection() {
    new StateManager({
        receiverTarget: 'dream-job-section',
        eventThatAssigns: 'click',
        defaultState: 'do-it',
    });

    bindDreamJobButtons();
}

function bindDreamJobButtons() {
    const dreamJobButtons = Array.from(document.querySelectorAll('[data-dream-job-switch]'));
    dreamJobButtons.forEach(dreamJobButton => {
        dreamJobButton.addEventListener('click', () => {
            const switchValue = dreamJobButton.getAttribute('data-dream-job-switch');

            ['data-dream-job-do-it', 'data-dream-job-work-it', 'data-dream-job-earn-it'].forEach(
                attribute => {
                    const dreamJobImage = document.querySelector(`[${attribute}]`);
                    if (dreamJobImage) {
                        dreamJobImage.removeAttribute('data-active');
                    }
                }
            );

            const activeImage = document.querySelector(`[${switchValue}]`);
            activeImage.setAttribute('data-active', '');
        });
    });
}
